import leftPad from './leftPad';

/**
 * Formats the passed number into a prettified display time.
 *
 * @param {Number} time Time to format.
 * @param {Boolean} includeMs True to include ms, false to not.
 * @return {String} Formatted time.
 */
export default function formatTime(time, includeMs = false) {
	// Convert float to int. Equivalent to `Math.floor`.
	// eslint-disable-next-line no-bitwise
	let milliseconds = time | 0;

	const h = Math.floor(milliseconds / (60 * 60 * 1000));
	milliseconds %= (60 * 60 * 1000);
	const m = Math.floor(milliseconds / (60 * 1000));
	milliseconds %= (60 * 1000);
	const s = Math.floor(milliseconds / 1000);

	let res = `${leftPad(2, h)}:${leftPad(2, m)}:${leftPad(2, s)}`;
	if (includeMs) {
		const ms = milliseconds % 1000;
		res += `:${leftPad(3, ms)}`;
	}
	return res;
}



// WEBPACK FOOTER //
// ./src/utils/formatTime.js